module.exports = __webpack_public_path__ + "./assets/img_hushan_grey@2x__1f87b918239f5803ef8596e9a38012f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/img_hushan_grey@2x.jpg
// module id = 628
// module chunks = 12